webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__song__ = __webpack_require__(69);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);




/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  modules: {
    home: __WEBPACK_IMPORTED_MODULE_2__home__["a" /* default */],
    song: __WEBPACK_IMPORTED_MODULE_3__song__["a" /* default */]
  }
}));

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_HOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_SLIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_SONG_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_ACTIVITY; });
/* unused harmony export HOT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_ARTICLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_SONG_TAG_LANG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_SONG_TAG_TEMPO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_SONG_LATEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_SONG_SPECIAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_SONG_SHARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_PARTNER_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UPDATEUSER; });
var LOGOUT = 'LOGOUT';
var LOGIN = 'LOGIN';
var SET_TOKEN = 'SET_TOKEN';
var SET_HOT = 'SET_HOT';
var SET_SLIDE = 'SET_SLIDE';
var SET_SONG_CATEGORY = 'SET_SONG_CATEGORY';
var SET_ACTIVITY = 'SET_ACTIVITY';
var HOT = 'HOT';
var SET_ARTICLE = 'ARTICLE';
var SET_SONG_TAG_LANG = 'SET_SONG_TAG_LANG';
var SET_SONG_TAG_TEMPO = 'SET_SONG_TAG_TEMPO';
var SET_SONG_LATEST = 'SET_SONG_LATEST';
var SET_SONG_SPECIAL = 'SET_SONG_SPECIAL';
var SET_SONG_SHARE = 'SET_SONG_SHARE';
var SET_PARTNER_CATEGORY = 'SET_PARTNER_CATEGORY';
var UPDATEUSER = 'UPDATEUSER';

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_SONG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_POPULAR; });
var SET_SONG = 'SET_SONG';
var SET_POPULAR = 'SET_POPULAR';

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(73),
  /* template */
  __webpack_require__(158),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);


// 使用一個空的 Vue 實例作為事件中心
var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();
Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype, '$bus', {
  get: function get() {
    return this.$root.bus;
  }
});
/* harmony default export */ __webpack_exports__["a"] = (bus);

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(15);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);

if (window.localStorage) {
  var uri = 'https://admin.weddingsung.com/api/';
  var downData = true;
  var Today = new Date();
  Today = Today.getFullYear() + '-' + (Today.getMonth() + 1) + '-' + Today.getDate();
  var dataTime = new Date(window.localStorage.getItem('dataTime'));
  dataTime = dataTime.getFullYear() + '-' + (dataTime.getMonth() + 1) + '-' + dataTime.getDate();
  // console.log(Today + '----' + dataTime)
  if (dataTime === null || Today !== dataTime) {
    downData = true;
  }

  var slide = window.localStorage.getItem('slide');
  if (slide === '' || slide === 'null' || downData === true) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(uri + 'Home/getData').then(function (res) {
      var data = res.data;
      // console.log(res)
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('SET_SLIDE', data.slide);
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('SET_SONG_CATEGORY', data.song_category);
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('SET_SONG_TAG_LANG', data.tag_lang);
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('SET_SONG_TAG_TEMPO', data.tag_tempo);
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('SET_SONG_LATEST', data.song_latest);
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('SET_SONG_SPECIAL', data.song_special);
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('SET_SONG_SHARE', data.share);
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('SET_PARTNER_CATEGORY', data.partner_category);
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('SET_ACTIVITY', data.activity);
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('SET_HOT', data.hots);
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('SET_ARTICLE', data.article);
    }).catch(function (response) {
      console.log('load fail');
    });
  } else {
    var songCategory = window.localStorage.getItem('songCategory');
    var songTagLang = window.localStorage.getItem('songTagLang');
    var songTagTempo = window.localStorage.getItem('songTagTempo');
    var songLatest = window.localStorage.getItem('songLatest');
    var songSpecial = window.localStorage.getItem('songSpecial');
    var songShare = window.localStorage.getItem('songShare');
    var partnerCategory = window.localStorage.getItem('partnerCategory');
    var activity = window.localStorage.getItem('activity');
    var hot = window.localStorage.getItem('hot');
    var article = window.localStorage.getItem('article');
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('SET_SLIDE', JSON.parse(slide));
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('SET_SONG_CATEGORY', JSON.parse(songCategory));
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('SET_SONG_TAG_LANG', JSON.parse(songTagLang));
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('SET_SONG_TAG_TEMPO', JSON.parse(songTagTempo));
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('SET_SONG_LATEST', JSON.parse(songLatest));
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('SET_SONG_SPECIAL', JSON.parse(songSpecial));
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('SET_SONG_SHARE', JSON.parse(songShare));
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('SET_PARTNER_CATEGORY', JSON.parse(partnerCategory));
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('SET_ACTIVITY', JSON.parse(activity));
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('SET_HOT', JSON.parse(hot));
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('SET_ARTICLE', JSON.parse(article));
  }

  var token = window.localStorage.getItem('token');
  if (token !== '' && token !== 'null') {
    var user = {
      userId: localStorage.getItem('userId'),
      userName: localStorage.getItem('userName'),
      userEmail: localStorage.getItem('userEmail'),
      token: localStorage.getItem('token')
    };
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('LOGIN', user);
  }
} else {
  console.log('不支援暫時存取服務。');
}

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Register__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Register__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Songs__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Songs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_Songs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_SongsView__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_SongsView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_SongsView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_SongsCatalog__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_SongsCatalog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_SongsCatalog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_SongsPick__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_SongsPick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_SongsPick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Search__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_About__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Contact__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_Contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Hot__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Hot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__views_Hot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Featured__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_Featured___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__views_Featured__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_FeaturedPage__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_FeaturedPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__views_FeaturedPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Partner__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_Partner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__views_Partner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Collection__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_Collection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__views_Collection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_Privacy__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_Privacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__views_Privacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_Topic__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_Topic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__views_Topic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_TopicView__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_TopicView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__views_TopicView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_MainSearch__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_MainSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__views_MainSearch__);





















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{
  path: '/',
  name: 'home',
  component: __WEBPACK_IMPORTED_MODULE_2__views_Home___default.a
}, {
  path: '/Login',
  component: __WEBPACK_IMPORTED_MODULE_2__views_Home___default.a,
  name: '登入'
}, {
  path: '/register',
  component: __WEBPACK_IMPORTED_MODULE_3__views_Register___default.a,
  name: '註冊',
  description: '註冊'
}, {
  path: '/privacy',
  component: __WEBPACK_IMPORTED_MODULE_16__views_Privacy___default.a,
  name: '隱私權政策',
  description: '隱私權政策'
}, {
  path: '/collection',
  component: __WEBPACK_IMPORTED_MODULE_15__views_Collection___default.a,
  name: '收藏歌曲',
  description: '收藏歌曲'
}, {
  path: '/about',
  component: __WEBPACK_IMPORTED_MODULE_9__views_About___default.a,
  name: '關於我們'
}, {
  path: '/hot',
  component: __WEBPACK_IMPORTED_MODULE_11__views_Hot___default.a,
  name: '熱門話題'
}, {
  path: '/songCategory/:id',
  component: __WEBPACK_IMPORTED_MODULE_4__views_Songs___default.a,
  name: '分類歌曲'
}, {
  path: '/featured',
  component: __WEBPACK_IMPORTED_MODULE_12__views_Featured___default.a,
  name: '頂上故事'
}, {
  path: '/featured/:id',
  component: __WEBPACK_IMPORTED_MODULE_13__views_FeaturedPage___default.a,
  name: '頂上故事內容'
}, {
  path: '/songsCatalog',
  component: __WEBPACK_IMPORTED_MODULE_6__views_SongsCatalog___default.a,
  name: '分類說明'
}, {
  path: '/songsPick',
  component: __WEBPACK_IMPORTED_MODULE_7__views_SongsPick___default.a,
  name: '挑歌秘訣'
}, {
  path: '/songs/:id',
  component: __WEBPACK_IMPORTED_MODULE_5__views_SongsView___default.a,
  name: '單篇歌曲'
}, {
  path: '/topic',
  component: __WEBPACK_IMPORTED_MODULE_17__views_Topic___default.a,
  name: '主題歌曲'
}, {
  path: '/topicview/:id',
  component: __WEBPACK_IMPORTED_MODULE_18__views_TopicView___default.a,
  name: '主題歌曲內容'
}, {
  path: '/search/:key',
  component: __WEBPACK_IMPORTED_MODULE_8__views_Search___default.a,
  name: 'search',
  beforeEnter: function beforeEnter(to, from, next) {
    console.log('Page search');
    next();
  }
}, {
  path: '/mainsearch/:key',
  component: __WEBPACK_IMPORTED_MODULE_19__views_MainSearch___default.a,
  name: 'mainsearch',
  beforeEnter: function beforeEnter(to, from, next) {
    console.log('Page mainSearch');
    next();
  }
}, {
  path: '/partner/:id',
  component: __WEBPACK_IMPORTED_MODULE_14__views_Partner___default.a,
  name: '相關夥伴'
}, {
  path: '/contact',
  component: __WEBPACK_IMPORTED_MODULE_10__views_Contact___default.a,
  name: '聯絡我們'
}];
/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 40 */,
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(159),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_qs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_paginate__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_analytics__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api_bus__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__static_scss_style_scss__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__static_scss_style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__static_scss_style_scss__);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










// import VueResource from 'vue-resource'

// import VueResource from 'vue-resource'




// import './assets/application.js'


var axiosInstance = __WEBPACK_IMPORTED_MODULE_6_axios___default.a.create({
  transformRequest: [function (data) {
    data = __WEBPACK_IMPORTED_MODULE_7_qs___default.a.stringify(data);
    return data;
  }]
});

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.devtools = true;
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_axios___default.a, axiosInstance);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_paginate___default.a);

var router = new __WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */]({
  mode: 'history',
  base: __dirname,
  routes: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */]
});

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_analytics___default.a, {
  id: 'UA-105063209-1',
  router: router
});

// Some middleware to help us ensure the user is authenticated.
router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    next();
  } else {
    next();
  }
});

if (__WEBPACK_IMPORTED_MODULE_12__api__["default"]) {
  console.log('Load Success');
}

/* eslint-disable */
new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
  el: '#app',
  data: function data() {
    return {
      bus: __WEBPACK_IMPORTED_MODULE_13__api_bus__["a" /* default */]
    };
  },

  created: function created() {
    (function (d, s, id) {
      var js,
          fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);js.id = id;
      js.src = "//connect.facebook.net/zh_TW/sdk.js#xfbml=1&version=v2.10&appId=1903095033298686";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');

    window.fbAsyncInit = function () {
      FB.init({
        appId: '1903095033298686',
        cookie: true,
        xfbml: true,
        version: 'v11.0'
      });
      FB.AppEvents.logPageView();
    };
  },
  store: __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */],
  router: router
}, __WEBPACK_IMPORTED_MODULE_3__App___default.a));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutations_types_js__ = __webpack_require__(23);

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_TOKEN: function SET_TOKEN(_ref, token) {
    var commit = _ref.commit;
    return commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["a" /* SET_TOKEN */], token);
  },
  LOGIN: function LOGIN(_ref2, param) {
    var commit = _ref2.commit;
    return commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["d" /* LOGIN */], { data: param });
  },
  LOGOUT: function LOGOUT(_ref3) {
    var commit = _ref3.commit;
    return commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["b" /* LOGOUT */]);
  },
  SET_HOT: function SET_HOT(_ref4, hot) {
    var commit = _ref4.commit;
    return commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["e" /* SET_HOT */], hot);
  },
  SET_ARTICLE: function SET_ARTICLE(_ref5, article) {
    var commit = _ref5.commit;
    return commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["o" /* SET_ARTICLE */], article);
  },
  SET_SLIDE: function SET_SLIDE(_ref6, slide) {
    var commit = _ref6.commit;
    return commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["f" /* SET_SLIDE */], slide);
  },
  SET_SONG_TAG_LANG: function SET_SONG_TAG_LANG(_ref7, songTagLang) {
    var commit = _ref7.commit;
    return commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["g" /* SET_SONG_TAG_LANG */], songTagLang);
  },
  SET_SONG_TAG_TEMPO: function SET_SONG_TAG_TEMPO(_ref8, songTagTempo) {
    var commit = _ref8.commit;
    return commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["h" /* SET_SONG_TAG_TEMPO */], songTagTempo);
  },
  SET_SONG_CATEGORY: function SET_SONG_CATEGORY(_ref9, songCategory) {
    var commit = _ref9.commit;
    return commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["i" /* SET_SONG_CATEGORY */], songCategory);
  },
  SET_ACTIVITY: function SET_ACTIVITY(_ref10, activity) {
    var commit = _ref10.commit;
    return commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["n" /* SET_ACTIVITY */], activity);
  },
  SET_SONG_LATEST: function SET_SONG_LATEST(_ref11, songLatest) {
    var commit = _ref11.commit;
    return commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["k" /* SET_SONG_LATEST */], songLatest);
  },
  SET_SONG_SPECIAL: function SET_SONG_SPECIAL(_ref12, songSpecial) {
    var commit = _ref12.commit;
    return commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["l" /* SET_SONG_SPECIAL */], songSpecial);
  },
  SET_SONG_SHARE: function SET_SONG_SHARE(_ref13, songShare) {
    var commit = _ref13.commit;
    return commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["j" /* SET_SONG_SHARE */], songShare);
  },
  SET_PARTNER_CATEGORY: function SET_PARTNER_CATEGORY(_ref14, partnerCategory) {
    var commit = _ref14.commit;
    return commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["m" /* SET_PARTNER_CATEGORY */], partnerCategory);
  },
  UPDATEUSER: function UPDATEUSER(_ref15, param) {
    var commit = _ref15.commit;
    return commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["c" /* UPDATEUSER */], { data: param });
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getAuth: function getAuth(state) {
    return state.authenticated;
  },
  getUri: function getUri(state) {
    return state.apiuri;
  },
  getTestUri: function getTestUri(state) {
    return state.testuri;
  },
  getHot: function getHot(state) {
    return state.hot;
  },
  getArticle: function getArticle(state) {
    return state.article;
  },
  getSlide: function getSlide(state) {
    return state.slide;
  },
  getSongCategory: function getSongCategory(state) {
    return state.songCategory;
  },
  getActivity: function getActivity(state) {
    return state.activity;
  },
  getSongTagLang: function getSongTagLang(state) {
    return state.songTagLang;
  },
  getSongTagTempo: function getSongTagTempo(state) {
    return state.songTagTempo;
  },
  getSongLatest: function getSongLatest(state) {
    return state.songLatest;
  },
  getSongSpecial: function getSongSpecial(state) {
    return state.songSpecial;
  },
  getSongShare: function getSongShare(state) {
    return state.songShare;
  },
  getPartnerCategory: function getPartnerCategory(state) {
    return state.partnerCategory;
  },
  getUserID: function getUserID(state) {
    return state.userId;
  },
  getUserName: function getUserName(state) {
    return state.userName;
  },
  getUserEmail: function getUserEmail(state) {
    return state.userEmail;
  },
  getToken: function getToken(state) {
    return state.token;
  }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters_js__ = __webpack_require__(64);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: __WEBPACK_IMPORTED_MODULE_1__mutations_js__["a" /* state */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions_js__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations_js__["b" /* mutations */],
  strict: true
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__ = __webpack_require__(23);



var _mutations;



var state = {
  userId: '',
  userName: '',
  userEmail: '',
  token: '',
  apiuri: 'https://admin.weddingsung.com/api/',
  testuri: 'http://songsadmin.localhost/api/',
  authenticated: false,
  hot: [],
  slide: [],
  songCategory: [],
  songTagLang: [],
  songTagTempo: [],
  songShare: [],
  partnerCategory: [],
  songLatest: [],
  songSpecial: [],
  activity: [],
  article: []
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["a" /* SET_TOKEN */], function (state, token) {
  state.token = token;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["b" /* LOGOUT */], function () {
  localStorage.removeItem('userId');
  localStorage.removeItem('userName');
  localStorage.removeItem('userEmail');
  localStorage.removeItem('token');
  state.userId = '';
  state.userName = '';
  state.userEmail = '';
  state.token = '';
  state.authenticated = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["c" /* UPDATEUSER */], function (state, creds) {
  var data = creds.data;
  if (localStorage) {
    state.userName = data.userName;
    state.userEmail = data.userEmail;
    localStorage.setItem('userName', data.userName);
    localStorage.setItem('userEmail', data.userEmail);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["d" /* LOGIN */], function (state, creds) {
  var data = creds.data;
  state.userId = data.userId;
  state.userName = data.userName;
  state.token = data.token;
  state.userEmail = data.userEmail;
  localStorage.setItem('userId', data.userId);
  localStorage.setItem('userName', data.userName);
  localStorage.setItem('token', data.token);
  localStorage.setItem('userEmail', data.userEmail);
  state.authenticated = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["e" /* SET_HOT */], function (state, data) {
  state.hot = data;
  localStorage.setItem('hot', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["f" /* SET_SLIDE */], function (state, data) {
  state.slide = data;
  localStorage.setItem('slide', data);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["g" /* SET_SONG_TAG_LANG */], function (state, data) {
  state.songTagLang = data;
  localStorage.setItem('songTagLang', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["h" /* SET_SONG_TAG_TEMPO */], function (state, data) {
  state.songTagTempo = data;
  localStorage.setItem('songTagTempo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["i" /* SET_SONG_CATEGORY */], function (state, data) {
  state.songCategory = data;
  localStorage.setItem('songCategory', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["j" /* SET_SONG_SHARE */], function (state, data) {
  state.songShare = data;
  localStorage.setItem('songShare', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["k" /* SET_SONG_LATEST */], function (state, data) {
  state.songLatest = data;
  localStorage.setItem('songLatest', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["l" /* SET_SONG_SPECIAL */], function (state, data) {
  state.songSpecial = data;
  localStorage.setItem('songSpecial', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["m" /* SET_PARTNER_CATEGORY */], function (state, data) {
  state.partnerCategory = data;
  localStorage.setItem('partnerCategory', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["n" /* SET_ACTIVITY */], function (state, data) {
  state.activity = data;
  localStorage.setItem('activity', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["e" /* SET_HOT */], function (state, data) {
  state.hot = data;
  localStorage.setItem('hot', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["o" /* SET_ARTICLE */], function (state, data) {
  state.article = data;
  localStorage.setItem('article', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
}), _mutations);

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutations_types_js__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  SET_SONG: function SET_SONG(_ref, song) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["a" /* SET_SONG */], song);
  },
  SET_POPULAR: function SET_POPULAR(_ref2, popular) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_0__mutations_types_js__["b" /* SET_POPULAR */], popular);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getSong: function getSong(state) {
    return state.song;
  },
  getPopular: function getPopular(state) {
    return state.popular;
  }
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters_js__ = __webpack_require__(68);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: __WEBPACK_IMPORTED_MODULE_1__mutations_js__["a" /* state */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions_js__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations_js__["b" /* mutations */],
  strict: true
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__ = __webpack_require__(24);



var _mutations;



var state = {
  song: [],
  popular: []
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["a" /* SET_SONG */], function (state, data) {
  state.song = data;
  window.localStorage.setItem('song', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_types_js__["b" /* SET_POPULAR */], function (state, data) {
  state.popular = data;
  window.localStorage.setItem('popular', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data));
}), _mutations);

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Topbar_vue__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Topbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layout_Topbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_Footbar_vue__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_Footbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layout_Footbar_vue__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      data: []
    };
  },

  components: {
    Topbar: __WEBPACK_IMPORTED_MODULE_0__components_layout_Topbar_vue___default.a,
    Footbar: __WEBPACK_IMPORTED_MODULE_1__components_layout_Footbar_vue___default.a
  },
  mounted: function mounted() {},
  methods: {
    onClickChild: function onClickChild(value) {
      console.log(value);
    }
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* eslint-disable */
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'fanspage',
  data: function data() {
    return {
      msg: ''
    };
  },

  mounted: function mounted() {}
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* eslint-disable */
/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['videoId'],
  name: 'fbcomment',
  data: function data() {
    return {
      msg: 'Footer'
    };
  },

  mounted: function mounted() {
    console.log(this.videoId);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'footbar',
  data: function data() {
    return {
      msg: 'Footer'
    };
  }
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["default"] = ({
  // props: ['userID'],
  name: 'topbar',
  data: function data() {
    return {
      uri: this.$store.getters.getUri,
      name: '',
      email: '',
      password: '',
      app_id: '',
      keyword: '',
      authorized: false,
      routerPath: 'mainsearch'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    UserName: 'getUserName'
  })),
  created: function created() {
    var token = window.localStorage.getItem('token');
    if (token === '' || token === 'null') {
      this.authorized = false;
    } else {
      this.authorized = this.$store.getters.getAuth;
    }
  },
  mounted: function mounted() {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['LOGIN', 'LOGOUT']), {
    userLogout: function userLogout() {
      var _this = this;

      this.$store.dispatch('LOGOUT').then(function () {
        _this.authorized = false;
        _this.$router.push('/');
      });
    },
    onClickButton: function onClickButton(event) {
      this.$emit('clicked', 'someValue');
    },
    getProfile: function getProfile() {
      var self = this;
      FB.api('/me?fields=name,id,email', function (response) {
        // vm.$set(vm, 'name', response.name)
        var str = '';
        console.log(response);
        if (response.email === '' || typeof response.email === 'undefined') {
          str += '取得信箱失敗\n';
        } else if (response.id === '' || typeof response.id === 'undefined') {
          str += 'APP ID 錯誤\n';
        }
        if (str === '') {
          var data = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify({
            app_id: response.id,
            email: response.email
          });
          self.$http.post(self.uri + 'User/fbLogin', data).then(function (res) {
            var data = res.data;
            console.log(data);
            if (data.status === 200) {
              var userData = {
                userId: data.uid,
                userName: data.name,
                userEmail: data.email,
                token: data.token
              };
              self.$store.dispatch('LOGIN', userData).then(function () {
                self.authorized = true;
                window.location.href = 'https://www.weddingsung.com/';
              });
            } else if (data.status === 510) {
              window.alert('取得資料失敗');
            }
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          window.alert('基本資料取得錯誤');
        }
      });
    },
    fblogin: function fblogin() {
      var vm = this;
      FB.login(function (response) {
        vm.statusChangeCallback(response);
      }, {
        scope: 'email, public_profile',
        return_scopes: true
      });
    },
    login: function login() {
      var str = '';
      if (this.email === '' || typeof this.email === 'undefined') {
        str += '請輸入您的信箱\n';
      } else if (this.password === '' || typeof this.password === 'undefined') {
        str += '請輸入您的密碼\n';
      }
      if (str === '') {
        var self = this;
        var data = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify({
          email: this.email,
          password: this.password
        });
        this.$http.post(this.uri + 'User/Login', data).then(function (res) {
          var data = res.data;
          if (data.status === 200) {
            var userData = {
              userId: data.uid,
              userName: data.name,
              userEmail: data.email,
              token: data.token
            };
            self.$store.dispatch('LOGIN', userData);
            self.authorized = true;
          } else if (data.status === 204) {
            window.alert('帳號尚未註冊。');
          } else if (data.status === 510) {
            window.alert('登入失敗。');
          } else if (data.status === 403) {
            window.alert('查無此組帳號，請先進行註冊。');
          }
          self.$router.go('/');
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        window.alert(str);
        return false;
      }
    },
    statusChangeCallback: function statusChangeCallback(response) {
      var vm = this;
      if (response.status === 'connected') {
        vm.getProfile();
      }
    },
    searching: function searching() {
      var keyword = this.keyword;
      console.log('go where:' + this.$route.fullPath);
      var path = void 0;

      if (this.$route.fullPath !== '/') {
        path = this.$route.fullPath.split('/');
        this.routerPath = path[1];
      }
      console.log('key :' + this.routerPath);

      if (this.routerPath !== 'mainsearch') {
        this.$router.push({ path: '/mainsearch/' + keyword });
      } else if (this.routerPath === 'mainsearch') {
        this.$router.push({ path: '/search/' + keyword });
      }

      // this.$router.push({ path: 'search', query: { keyword: keyword }})
      // this.$router.go('/search/' + keyword)

      // this.$router.replace({ name: 'search',force: true, params: { key: keyword }})
    }
  })
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about',
  data: function data() {
    return {
      category: []
    };
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'collection',
  data: function data() {
    return {
      uri: this.$store.getters.getUri,
      token: this.$store.getters.getToken,
      saveSongData: Object,
      songdata: Object,
      chooseLang: '',
      chooseTempo: '',
      songQty: 0,
      keyword: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    lang: 'getSongTagLang',
    tempo: 'getSongTagTempo'
  })),
  mounted: function mounted() {
    this.loadCollection();
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['UPDATEUSER']), {
    loadCollection: function loadCollection() {
      var self = this;
      if (this.token !== '') {
        var uploadData = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify({
          token: this.token
        });
        this.$http.post(this.uri + 'Song/song_collection', uploadData).then(function (res) {
          var data = res.data;
          if (data.status === 200) {
            self.songdata = data.songs;
            self.saveSongData = data.songs;
            return data.songs;
          } else {
            console.log('下載歌曲失敗');
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        return false;
      }
    },
    filterSong: function filterSong() {
      var lang = this.chooseLang;
      var tempo = this.chooseTempo;
      this.songdata = this.saveSongData;
      if (lang !== '') {
        this.songdata = this.songdata.filter(function (value) {
          return value.tag_1.indexOf(lang) >= 0;
        });
      }
      if (tempo !== '') {
        this.songdata = this.songdata.filter(function (value) {
          return value.tag_3.indexOf(tempo) >= 0;
        });
      }
      if (this.songdata.length < 1) {
        window.alert('尚無歌曲');
      }
    },
    filterKeyword: function filterKeyword() {
      var keyword = this.keyword;
      if (keyword !== '') {
        this.songdata = this.songdata.filter(function (value) {
          return value.author.indexOf(keyword) >= 0 || value.title.indexOf(keyword) >= 0;
        });
      } else {
        this.songdata = this.saveSongData;
      }
    }
  }),
  watch: {
    chooseLang: {
      handler: function handler(val, oldVal) {
        this.filterSong();
      }
    },
    chooseTempo: {
      handler: function handler(val, oldVal) {
        this.filterSong();
      }
    },
    keyword: {
      handler: function handler(val, oldVal) {
        this.filterKeyword();
      }
    }
  }
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contact',
  data: function data() {
    return {
      uri: this.$store.getters.getUri,
      name: '',
      email: '',
      context: 'test'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getUri', 'getTestUri'])),
  mounted: function mounted() {},
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['UPDATEUSER']), {
    addContact: function addContact() {
      var str = '';
      // console.log(this.UserID)
      if (this.name === '') {
        str += '請填寫個人姓名。\n';
      } else if (this.email === '' || typeof this.email === 'undefined') {
        str += '請輸入您的信箱\n';
      }
      if (str === '') {
        var data = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify({
          name: this.name,
          email: this.email,
          context: this.context
        });
        this.$http.post(this.uri + 'Contact/add_contact', data).then(function (res) {
          var data = res.data;
          console.log(data);
          if (data.status === 200) {
            window.alert('我們已收到您的訊息，將盡快與您聯繫，謝謝');
          } else {
            window.alert('填寫失敗。');
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        window.alert(str);
        return false;
      }
    }
  })
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'featured',
  data: function data() {
    return {
      uri: this.$store.getters.getUri,
      featured: Object
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getUri'])),
  mounted: function mounted() {
    var self = this;
    this.$http.get(this.uri + 'Article/getArticle').then(function (res) {
      var data = res.data;
      if (data.status === 200) {
        self.featured = data.articles;
      } else {
        console.log('下載頂上文章失敗');
      }
    }).catch(function (error) {
      console.log(error);
    });
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['UPDATEUSER']))
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FeaturedPage',
  data: function data() {
    return {
      uri: this.$store.getters.getUri,
      userId: this.$store.getters.getUserID,
      article: Object
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getUri'])),
  mounted: function mounted() {
    // let article = window.localStorage.getItem('article')
    // article = JSON.parse(article)
    // let id = this.$route.params.id
    // let data = article.filter(function (value) {
    //   // console.log('id:' + id + '====' + value.id)
    //   return value.id === id
    // })
    // this.article = data[0]
    // console.dir('id' + JSON.stringify(this.article))
    var self = this;
    var dataPost = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify({
      id: this.$route.params.id
    });
    self.$http.post(this.uri + 'Article/getAnArticle', dataPost).then(function (res) {
      var data = res.data;
      if (data.status === 200) {
        self.article = data.article;
      } else {
        console.log('fail');
      }
    }).catch(function (error) {
      console.log(error);
    });
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['UPDATEUSER']))
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Fanspage_vue__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Fanspage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Fanspage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {
      api: this.$store.getters.getUri
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])({
    slide: 'getSlide',
    songCategory: 'getSongCategory',
    songLatest: 'getSongLatest',
    songSpecial: 'getSongSpecial',
    SongShare: 'getSongShare',
    partnerCategory: 'getPartnerCategory',
    activity: 'getActivity',
    article: 'getArticle',
    hot: 'getHot'
  })),
  components: {
    Fanspage: __WEBPACK_IMPORTED_MODULE_1__components_Fanspage_vue___default.a
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['UPDATEUSER'])),
  filters: {
    truncate: function truncate(string, value) {
      var str = string.replace(/<\/?[^>]+(>|$)/g, '');
      return str;
    },
    doubledot: function doubledot(str, value) {
      str = str.replace(/&quot;*/g, '"');
      str = str.replace(/&amp;*/g, '&');
      return str.substring(0, value) + '...';
    }
  }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hot',
  data: function data() {
    return {
      uri: this.$store.getters.getUri,
      hot: Object
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getUri'])),
  mounted: function mounted() {
    var self = this;
    this.$http.get(this.uri + 'hot/getHot').then(function (res) {
      var data = res.data;
      if (data.status === 200) {
        self.hot = data.hots;
      } else {
        console.log('下載熱門話題失敗');
      }
    }).catch(function (error) {
      console.log(error);
    });
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['UPDATEUSER']))
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mainsearch',
  data: function data() {
    return {
      uri: this.$store.getters.getUri,
      keyword: 0,
      songdata: Object,
      tempsongdata: Object,
      chooseLang: '',
      chooseTempo: '',
      pics: Object
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    lang: 'getSongTagLang',
    tempo: 'getSongTagTempo'
  })),
  mounted: function mounted() {
    this.keyword = this.$route.params.key;
    this.searching();
    var self = this;
    this.$http.get(this.uri + 'Home/get_search_page_pic').then(function (res) {
      var data = res.data;
      if (data.status === 200) {
        self.pics = data.slide;
        console.log('data: ' + self.pics);
        return data.slide;
      } else {
        console.log('下載圖片失敗');
      }
    }).catch(function (error) {
      console.log(error);
    });
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['UPDATEUSER']), {
    searching: function searching() {
      var uploadData = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify({
        keyword: this.keyword
      });
      var self = this;
      // 取得搜尋歌曲
      if (this.keyword !== '') {
        this.$http.post(this.uri + 'Song/get_song_by_keyword', uploadData).then(function (res) {
          var data = res.data;
          if (data.status === 200) {
            self.songdata = self.tempsongdata = data.songs;
            return data.songs;
          } else {
            console.log('下載歌曲失敗');
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        window.alert('請輸入關鍵字再進行搜尋。');
      }
    },
    filterSong: function filterSong() {
      var lang = this.chooseLang;
      var tempo = this.chooseTempo;
      this.songdata = this.tempsongdata;
      if (lang !== '') {
        this.songdata = this.songdata.filter(function (value) {
          console.log(value);
          return value.tag_1.indexOf(lang) >= 0;
        });
      }
      if (tempo !== '') {
        this.songdata = this.songdata.filter(function (value) {
          return value.tag_3.indexOf(tempo) >= 0;
        });
      }
      if (this.songdata.length < 1) {
        window.alert('尚無歌曲');
      }
      // console.log('filter' + tempo)
    }
  }),
  watch: {
    chooseLang: {
      handler: function handler(val, oldVal) {
        this.filterSong();
      }
    },
    chooseTempo: {
      handler: function handler(val, oldVal) {
        this.filterSong();
      }
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'partner',
  data: function data() {
    return {
      uri: this.$store.getters.getUri,
      partner: [],
      categoryId: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getUri']), {
    getCategory: function getCategory() {
      return this.$store.getters.getPartnerCategory[this.$route.params.id - 1];
    }
  }),
  mounted: function mounted() {
    this.categoryId = this.$route.params.id;
    this.searching();
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['UPDATEUSER']), {
    searching: function searching() {
      var self = this;
      if (this.categoryId !== '') {
        this.$http.get(this.uri + 'Partner/get_partners_by_category/' + this.categoryId).then(function (res) {
          var data = res.data;
          if (data.status === 200) {
            self.partner = data.partners;
          } else {
            console.log('下載夥伴資料失敗');
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        return false;
      }
    }
  })
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'privacy',
  data: function data() {
    return {
      msg: ''
    };
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'register',
  data: function data() {
    return {
      uri: this.$store.getters.getUri,
      name: '',
      email: '',
      password: '',
      password2: '',
      app_id: '',
      agreement: '',
      fblogin: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getUri', 'getTestUri'])),
  mounted: function mounted() {
    var vm = this;
    window.fbAsyncInit = function () {
      FB.init({
        appId: '1903095033298686',
        cookie: true,
        xfbml: true,
        version: 'v2.8'
      });
      FB.AppEvents.logPageView();
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['UPDATEUSER']), {
    getProfile: function getProfile() {
      var vm = this;
      FB.api('/me?fields=name,id,email', function (response) {
        // console.log(response)
        vm.$set(vm, 'name', response.name);
        vm.$set(vm, 'email', response.email);
        vm.$set(vm, 'app_id', response.id);
      });
    },
    login: function login() {
      var vm = this;
      FB.login(function (response) {
        vm.statusChangeCallback(response);
      }, {
        scope: 'email, public_profile',
        return_scopes: true
      });
      this.fblogin = 1;
    },
    statusChangeCallback: function statusChangeCallback(response) {
      var vm = this;
      console.log(response);
      if (response.status === 'connected') {
        vm.getProfile();
      }
    },
    register: function register() {
      var str = '';
      // console.log(this.UserID)
      if (this.name === '') {
        str += '請填寫個人姓名。\n';
      } else if (this.email === '' || typeof this.email === 'undefined') {
        str += '請輸入您的信箱\n';
      } else if (this.password === '' || typeof this.password === 'undefined') {
        str += '請輸入您的密碼\n';
      } else if (this.password !== this.password2) {
        str += '您兩次輸入的密碼不同，請再次輸入。\n';
      } else if (this.agreement === '') {
        str += '請勾選個人隱私權條款。\n';
      }
      if (str === '') {
        var data = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify({
          name: this.name,
          email: this.email,
          password: this.password,
          app_id: this.app_id
        });
        this.$http.post(this.uri + 'User/fbRegister', data).then(function (res) {
          var data = res.data;
          console.log(data);
          if (data.status === 200) {
            window.alert('註冊成功');
          } else if (data.status === 512) {
            window.alert('帳號註冊失敗。');
          } else if (data.status === 513) {
            window.alert('註冊失敗，請填寫完整資料。');
          } else if (data.status === 511) {
            window.alert('此帳號已經被註冊過。');
          }
          this.$router.go('/');
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        window.alert(str);
        return false;
      }
    }
  })
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search',
  data: function data() {
    return {
      uri: this.$store.getters.getUri,
      keyword: 0,
      songdata: Object,
      tempsongdata: Object,
      chooseLang: '',
      chooseTempo: '',
      pics: Object
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    lang: 'getSongTagLang',
    tempo: 'getSongTagTempo'
  })),
  mounted: function mounted() {
    this.keyword = this.$route.params.key;
    this.searching();
    var self = this;
    this.$http.get(this.uri + 'Home/get_search_page_pic').then(function (res) {
      var data = res.data;
      if (data.status === 200) {
        self.pics = data.slide;
        console.log('data: ' + self.pics);
        return data.slide;
      } else {
        console.log('下載圖片失敗');
      }
    }).catch(function (error) {
      console.log(error);
    });
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['UPDATEUSER']), {
    searching: function searching() {
      var uploadData = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify({
        keyword: this.keyword
      });
      var self = this;
      // 取得搜尋歌曲
      if (this.keyword !== '') {
        this.$http.post(this.uri + 'Song/get_song_by_keyword', uploadData).then(function (res) {
          var data = res.data;
          if (data.status === 200) {
            self.songdata = self.tempsongdata = data.songs;
            return data.songs;
          } else {
            console.log('下載歌曲失敗');
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        window.alert('請輸入關鍵字再進行搜尋。');
      }
    },
    filterSong: function filterSong() {
      var lang = this.chooseLang;
      var tempo = this.chooseTempo;
      this.songdata = this.tempsongdata;
      if (lang !== '') {
        this.songdata = this.songdata.filter(function (value) {
          console.log(value);
          return value.tag_1.indexOf(lang) >= 0;
        });
      }
      if (tempo !== '') {
        this.songdata = this.songdata.filter(function (value) {
          return value.tag_3.indexOf(tempo) >= 0;
        });
      }
      if (this.songdata.length < 1) {
        window.alert('尚無歌曲');
      }
    }
  }),
  watch: {
    chooseLang: {
      handler: function handler(val, oldVal) {
        this.filterSong();
      }
    },
    chooseTempo: {
      handler: function handler(val, oldVal) {
        this.filterSong();
      }
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'songs',
  data: function data() {
    return {
      uri: this.$store.getters.getUri,
      categoryId: 0,
      category: {},
      songdata: Object,
      saveSongData: Object,
      songLatest: Object,
      chooseLang: '',
      chooseTempo: '',
      songQty: 0,
      keyword: '',
      paginate: ['languages']
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    lang: 'getSongTagLang',
    tempo: 'getSongTagTempo'
  }), {
    getCategory: function getCategory() {
      return this.$store.getters.getSongCategory[this.$route.params.id - 1];
    }
  }),
  mounted: function mounted() {
    this.categoryId = this.$route.params.id;
    this.searching();
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['UPDATEUSER']), {
    searching: function searching() {
      var self = this;
      // 取得分類中的歌曲
      if (this.categoryId !== '') {
        var uploadData = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify({
          categoryId: this.categoryId
        });
        this.$http.post(this.uri + 'Song/get_songs_by_category', uploadData).then(function (res) {
          var data = res.data;
          if (data.status === 200) {
            // self.songdata = data.songs
            self.saveSongData = data.songs;
            self.songLatest = data.songsLatest;
            self.songQty = data.songs.length;
          } else {
            console.log('下載歌曲失敗');
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        return false;
      }
    },
    filterSong: function filterSong() {
      var lang = this.chooseLang;
      var tempo = this.chooseTempo;
      this.songdata = this.saveSongData;
      if (lang !== '') {
        this.songdata = this.songdata.filter(function (value) {
          return value.tag_1.indexOf(lang) >= 0;
        });
      }
      if (tempo !== '') {
        this.songdata = this.songdata.filter(function (value) {
          return value.tag_3 === tempo;
        });
        console.log(this.songdata.length + '總筆');
      }
      if (this.songdata.length < 1) {
        window.alert('尚無歌曲');
      }
    },
    filterKeyword: function filterKeyword() {
      var keyword = this.keyword;
      if (keyword !== '') {
        this.songdata = this.songdata.filter(function (value) {
          return value.author.indexOf(keyword) >= 0 || value.title.indexOf(keyword) >= 0;
        });
      } else {
        this.songdata = this.saveSongData;
      }
    }
    // this.$store.dispatch('b')

  }),
  watch: {
    chooseLang: {
      handler: function handler(val, oldVal) {
        this.filterSong();
      }
    },
    chooseTempo: {
      handler: function handler(val, oldVal) {
        this.filterSong();
      }
    },
    keyword: {
      handler: function handler(val, oldVal) {
        this.filterKeyword();
      }
    }
  }
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'songscatalog',
  data: function data() {
    return {
      category: []
    };
  },

  mounted: function mounted() {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    songCategory: 'getSongCategory'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['UPDATEUSER']))
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'songspick',
  data: function data() {
    return {
      category: []
    };
  },

  mounted: function mounted() {},
  methods: {}
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Fbcomment_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Fbcomment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Fbcomment_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'songsview',
  data: function data() {
    return {
      uri: this.$store.getters.getUri,
      userId: this.$store.getters.getUserID,
      token: this.$store.getters.getToken,
      songId: this.$route.params.id,
      songView: Object,
      share: [],
      name: '',
      link: '',
      context: '',
      favoriteData: {
        active: false
      },
      favorite: 0
    };
  },

  components: {
    Fbcomment: __WEBPACK_IMPORTED_MODULE_2__components_Fbcomment_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getUri'])),
  created: function created() {
    var token = window.localStorage.getItem('token');
    if (token === '' || token === 'null') {
      this.authorized = false;
      console.log(this.authorized);
    } else {
      this.authorized = this.$store.getters.getAuth;
      console.log(this.authorized);
    }
    var self = this;
    var dataPost = __WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify({
      token: this.token,
      song_id: this.songId,
      user_id: this.user_id
    });
    self.$http.post(this.uri + 'Song/get_song/', dataPost).then(function (res) {
      var data = res.data;
      if (data.status === 200) {
        self.songView = data.song;
        self.share = data.share;
        if (data.song.favoriteID > 0) {
          self.favoriteData.active = true;
        }
      } else {
        console.log('fail');
      }
    }).catch(function (error) {
      console.log(error);
    });
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['UPDATEUSER']), {
    addToFavorite: function addToFavorite() {
      var str = '';
      var self = this;
      if (this.favoriteData.active === true) {
        str += '您已經收藏過此首歌曲\n';
      } else if (this.token === '' || typeof this.token === 'undefined') {
        str += '請您先登入，再進行收藏\n';
      }
      if (str === '') {
        var data = __WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify({
          token: this.token,
          song_id: this.songId
        });
        this.$http.post(this.uri + 'User/add_song_favorite', data).then(function (res) {
          var data = res.data;
          if (data.status === 200) {
            self.favoriteData.active = true;
            window.alert('收藏成功');
          } else {
            window.alert('收藏失敗');
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        window.alert(str);
        return false;
      }
    },
    shareSong: function shareSong() {
      var str = '';
      if (this.name === '' || typeof this.name === 'undefined') {
        str += '請輸入您的信箱\n';
      } else if (this.link === '' || typeof this.link === 'undefined') {
        str += '輸入影片連結\n';
      }
      if (str === '') {
        var data = __WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify({
          name: this.name,
          link: this.link,
          context: this.context,
          user_id: this.userId,
          song_id: this.songId,
          title: this.songView.title
        });
        this.$http.post(this.uri + 'Share/add_share_song/', data).then(function (res) {
          var data = res.data;
          if (data.status === 200) {
            window.alert('上傳成功，謝謝您的分享');
            this.name = '';
            this.context = '';
            this.link = '';
          } else {
            console.log('fail');
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        window.alert(str);
        return false;
      }
    }
  })
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'topic',
  data: function data() {
    return {
      uri: this.$store.getters.getUri,
      categoryId: 6,
      category: {},
      songdata: Object,
      songLatest: Object
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    lang: 'getSongTagLang'
  }), {
    getCategory: function getCategory() {
      return this.$store.getters.getSongCategory[6 - 1];
    }
  }),
  mounted: function mounted() {
    this.searching();
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['UPDATEUSER']), {
    searching: function searching() {
      var self = this;
      // 取得分類中的歌曲
      if (this.categoryId !== '') {
        var uploadData = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify({
          categoryId: this.categoryId
        });
        this.$http.post(this.uri + 'Song/get_songs_by_category', uploadData).then(function (res) {
          var data = res.data;
          if (data.status === 200) {
            self.songdata = data.songs;
            self.songLatest = data.songsLatest;
          } else {
            console.log('下載歌曲失敗');
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        return false;
      }
    }
  })
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Fbcomment_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Fbcomment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Fbcomment_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'topicview',
  data: function data() {
    return {
      uri: this.$store.getters.getUri,
      userId: this.$store.getters.getUserID,
      token: this.$store.getters.getToken,
      songId: 0,
      songView: Object,
      name: '',
      link: '',
      context: ''
    };
  },

  components: {
    Fbcomment: __WEBPACK_IMPORTED_MODULE_2__components_Fbcomment_vue___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['getUri'])),
  created: function created() {
    this.songId = this.$route.params.id;
    var self = this;
    var dataPost = __WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify({
      token: this.token,
      song_id: this.songId
    });
    self.$http.post(this.uri + 'Song/get_song/', dataPost).then(function (res) {
      var data = res.data;
      if (data.status === 200) {
        self.songView = data.song;
      } else {
        console.log('fail');
      }
    }).catch(function (error) {
      console.log(error);
    });
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['UPDATEUSER']))
});

/***/ }),
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(165),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(170),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(161),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(162),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(168),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(125)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(78),
  /* template */
  __webpack_require__(166),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-762fcfc8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(163),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(174),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(152),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(169),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(164),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(153),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(155),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(156),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(154),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(172),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(160),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(167),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(157),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(171),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(173),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "main-banner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('div', {
    staticClass: "carousel slide",
    attrs: {
      "id": "bs-slider",
      "data-ride": "carousel"
    }
  }, [_c('ol', {
    staticClass: "carousel-indicators"
  }, _vm._l((_vm.slide), function(row, index) {
    return _c('li', {
      class: [index == 0 ? 'active' : ''],
      attrs: {
        "data-target": "#bs-slider",
        "data-slide-to": 0
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "carousel-inner",
    attrs: {
      "role": "listbox"
    }
  }, _vm._l((_vm.slide), function(row, index) {
    return _c('div', {
      staticClass: "carousel-item",
      class: [index == 0 ? 'active' : '']
    }, [_c('img', {
      staticClass: "d-block img-fluid",
      attrs: {
        "src": 'https://admin.weddingsung.com/upload/slide/' + row.image_path,
        "alt": index
      }
    })])
  }), 0), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "articles-box exlink-box"
  }, [_c('a', {
    attrs: {
      ":href": '/Featured',
      "target": "_blink"
    }
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("頂上故事-" + _vm._s(_vm.article[0].title))]), _vm._v(" "), _c('span', {
    staticClass: "pub_date text-primary"
  }, [_vm._v("\n                                  " + _vm._s(_vm.article[0].created_at) + "\n                              ")]), _vm._v(" "), _c('router-link', {
    staticClass: "more_link",
    attrs: {
      "to": '/Featured'
    }
  }, [_vm._v("more")]), _vm._v(" "), _c('article', {
    staticClass: "article-editor"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.article[0].context)
    }
  })])], 1)]), _vm._v(" "), _vm._l((_vm.hot), function(row, index) {
    return _c('div', {
      staticClass: "articles-box exlink-box"
    }, [_c('a', {
      attrs: {
        "href": row.link,
        "target": "_blink"
      }
    }, [_c('h5', {
      staticClass: "title"
    }, [_vm._v("熱門話題-" + _vm._s(row.title))]), _vm._v(" "), _c('span', {
      staticClass: "pub_date text-primary"
    }, [_vm._v(_vm._s(row.created_at))]), _vm._v(" "), _c('article', {
      staticClass: "article-editor"
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(row.context)
      }
    })])])])
  }), _vm._v(" "), (_vm.songSpecial.id > 0) ? _c('div', {
    staticClass: "articles-box exlink2"
  }, [_c('a', {
    attrs: {
      "href": '/topicview/' + _vm.songSpecial.id
    }
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("特別企劃")]), _vm._v(" "), _c('span', {
    staticClass: "sub-title  text-primary"
  }, [_vm._v(_vm._s(_vm.songSpecial.title))]), _vm._v(" "), _c('article', {
    staticClass: "article-image"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": 'https://admin.weddingsung.com/upload/song/' + _vm.songSpecial.image_path
    }
  })])])]) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles bck-index-bg"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_vm._l((_vm.songLatest), function(row, index) {
    return _c('div', {
      staticClass: "articles-box refsongs-box"
    }, [(index === 0) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-5"
    }, [_c('div', {
      staticClass: "embed-responsive embed-responsive-16by9"
    }, [_c('iframe', {
      staticClass: "embed-responsive-item",
      attrs: {
        "src": _vm.songLatest[0].link
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-7"
    }, [_c('div', {
      staticClass: "text"
    }, [_c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.songLatest[0].title))]), _vm._v(" "), _c('span', {
      staticClass: "pub_date text-primary"
    }, [_vm._v(_vm._s(_vm.songLatest[0].updated_at))]), _vm._v(" "), _c('article', {
      staticClass: "article-editor"
    }, [_c('p', {
      staticClass: "txt"
    }, [_vm._v("\n                                                    " + _vm._s(_vm._f("doubledot")(_vm._f("truncate")(_vm.songLatest[0].context, 250))) + "\n                                                ")])]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-outline-primary btn-sm",
      attrs: {
        "href": '/songs/' + _vm.songLatest[0].id
      }
    }, [_vm._v("MORE")])])])]) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.songLatest), function(row, index) {
    return _c('div', {
      staticClass: "articles-box refsongs-box"
    }, [(index === 1) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-5 push-md-7"
    }, [_c('div', {
      staticClass: "embed-responsive embed-responsive-16by9"
    }, [_c('iframe', {
      staticClass: "embed-responsive-item",
      attrs: {
        "src": row.link
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-7 pull-md-5"
    }, [_c('div', {
      staticClass: "text"
    }, [_c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('span', {
      staticClass: "pub_date text-primary"
    }, [_vm._v(_vm._s(row.updated_at))]), _vm._v(" "), _c('article', {
      staticClass: "article-editor"
    }, [_c('p', {
      staticClass: "txt"
    }, [_vm._v("\n                                                  " + _vm._s(_vm._f("doubledot")(_vm._f("truncate")(row.context, 250))) + "\n                                                ")])]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-outline-primary btn-sm",
      attrs: {
        "href": '/songs/' + row.id
      }
    }, [_vm._v("MORE")])])])]) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "bck-index bck-articles"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('div', {
    staticClass: "articles-box refsongs-box ref-hn"
  }, _vm._l((_vm.SongShare), function(row, index) {
    return _c('div', {
      staticClass: "row",
      staticStyle: {
        "margin-bottom": "20px"
      }
    }, [_c('div', {
      staticClass: "col-md-5"
    }, [_c('div', {
      staticClass: "embed-responsive embed-responsive-16by9"
    }, [_c('iframe', {
      staticClass: "embed-responsive-item",
      attrs: {
        "src": row.link
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-7"
    }, [_c('div', {
      staticClass: "text"
    }, [_c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('span', {
      staticClass: "pub_date text-primary"
    }, [_vm._v(_vm._s(row.created_at))]), _vm._v(" "), _c('article', {
      staticClass: "article-editor"
    }, [_c('p', [_vm._v(_vm._s(_vm._f("doubledot")(row.context)))])]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-outline-primary btn-sm",
      attrs: {
        "href": '/songs/' + row.song_id
      }
    }, [_vm._v("MORE")])])])])
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.songCategory), function(row, index) {
    return _c('div', {
      staticClass: "col-lg-4 col-md-6"
    }, [_c('div', {
      staticClass: "articles-box catalog-box"
    }, [(row.id == 6) ? _c('a', {
      attrs: {
        "href": '/topic/'
      }
    }, [_c('figure', {
      staticClass: "pic articles-pic fitimg"
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": 'https://admin.weddingsung.com/upload/song/' + row.image_path
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(row.title) + " (" + _vm._s(row.qty) + ")")]), _vm._v(" "), _c('article', {
      staticClass: "article-editor",
      domProps: {
        "innerHTML": _vm._s(row.context)
      }
    })])]) : _c('a', {
      attrs: {
        "href": '/songCategory/' + row.id
      }
    }, [_c('figure', {
      staticClass: "pic articles-pic fitimg"
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": 'https://admin.weddingsung.com/upload/song/' + row.image_path
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(row.title) + " (" + _vm._s(row.qty) + ")")]), _vm._v(" "), _c('article', {
      staticClass: "article-editor",
      domProps: {
        "innerHTML": _vm._s(row.context)
      }
    })])])])])
  }), 0)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "carousel-control-prev",
    attrs: {
      "href": "#bs-slider",
      "role": "button",
      "data-slide": "prev"
    }
  }, [_c('span', {
    staticClass: "carousel-control-prev-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Previous")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "carousel-control-next",
    attrs: {
      "href": "#bs-slider",
      "role": "button",
      "data-slide": "next"
    }
  }, [_c('span', {
    staticClass: "carousel-control-next-icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Next")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title"
  }, [_c('span', [_vm._v("本週推薦歌曲")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title title-bg-flowers"
  }, [_c('span', [_vm._v("歌曲使用分享")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title title-bg-music"
  }, [_c('span', [_vm._v("精選分類")])])
}]}

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_c('h3', {
    staticClass: "title title-bg-bird"
  }, [_c('span', [_vm._v("相關夥伴 " + _vm._s(this.getCategory.title))])]), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('div', {
    staticClass: "row strict7"
  }, _vm._l((_vm.partner), function(row, index) {
    return _c('div', {
      staticClass: "col-md-3 col-sm-4"
    }, [_c('div', {
      staticClass: "articles-box news-box"
    }, [_c('a', {
      attrs: {
        "href": row.link,
        "target": "_blink"
      }
    }, [_c('figure', {
      staticClass: "articles-fitimg"
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": 'https://admin.weddingsung.com/upload/partner/' + row.image_path
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text text-center"
    }, [_c('h5', {
      staticClass: "title text-primary"
    }, [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('p', {
      staticClass: "txt",
      domProps: {
        "innerHTML": _vm._s(row.context)
      }
    })])])])])
  }), 0)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-banner inner-banner-bg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "articles-box"
  }, [_c('figure', {
    staticClass: "pic articles-pic fitimg mb-0"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "https://admin.weddingsung.com/upload/slide/88311b59e2e2c107d44366e24d81f644.png"
    }
  })])])])])
}]}

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "inner-banner inner-banner-bg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "articles-box"
  }, _vm._l((_vm.pics), function(row, index) {
    return _c('figure', {
      staticClass: "pic articles-pic fitimg mb-0"
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": 'https://admin.weddingsung.com/upload/slide/' + row.image_path
      }
    })])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('form', {
    staticClass: "form-inline"
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "inlineFormCustomSelect"
    }
  }, [_vm._v("挑選歌曲")]), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "inlineFormCustomSelect"
    }
  }, [_vm._v("語文")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chooseLang),
      expression: "chooseLang"
    }],
    staticClass: "custom-select mb-2 mr-sm-2 mb-sm-0",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.chooseLang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.lang), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                        " + _vm._s(option.title) + "\n                                    ")])
  })], 2), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "inlineFormCustomSelect"
    }
  }, [_vm._v("節奏")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chooseTempo),
      expression: "chooseTempo"
    }],
    staticClass: "custom-select mb-2 mr-sm-2 mb-sm-0",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.chooseTempo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.tempo), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                        " + _vm._s(option.title) + "\n                                    ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "song-list"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.songdata), function(row, index) {
    return _c('div', {
      staticClass: "song-item row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_vm._v(_vm._s(row.author))]), _vm._v(" "), _c('div', {
      staticClass: "col-xl-3 col-md-2"
    }, [_vm._v(_vm._s(row.created_at.substr(0, 10)))]), _vm._v(" "), _c('div', {
      staticClass: "col-xl-1 col-md-2 text-center"
    }, [_c('router-link', {
      staticClass: "btn-song-detail",
      attrs: {
        "to": '/Songs/' + row.id
      }
    }, [_vm._v("聆聽去")])], 1)])
  })], 2)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title"
  }, [_c('span', [_vm._v("搜尋結果")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "song-item song-mainitem row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("歌曲")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("歌者")]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-3 col-md-2"
  }, [_vm._v("刊登時間")]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-1 col-md-2"
  })])
}]}

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_c('h3', {
    staticClass: "title sr-only"
  }, [_c('span', [_vm._v("推薦歌曲 - 歌詞與video")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 offset-md-1 col-12"
  }, [_c('article', {
    staticClass: "article-editor"
  }, [_c('h3', {
    staticClass: "text-primary text-center"
  }, [_vm._v("會員隱私權保護政策")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("「桅頂上」網站非常重視您的隱私權。請您閱讀以下有關隱私權保護政策的更多內容。")]), _vm._v(" "), _c('p', [_vm._v("本政策內容主要包括：「桅頂上」如何處理蒐集或收到的個人資料 (包括您過去使用 「桅頂上」產品及服務相關的資料）。個人資料是指得以識別您的身分且未公開的資料，如姓名、地址、電子郵件地址或電話號碼。")]), _vm._v(" "), _c('p', [_vm._v("本隱私權保護政策只適用於 「桅頂上」。本政策不適用於非 「桅頂上」所有或控制的公司，也不適用於非 「桅頂上」僱用或管理之人。")]), _vm._v(" "), _c('p', [_vm._v("說明如下")]), _vm._v(" "), _c('p', [_vm._v("在您註冊 「桅頂上」帳號、使用 「桅頂上」產品或服務、瀏覽 「桅頂上」網頁或某些合作夥伴的網頁，以及參加宣傳活動或贈獎遊戲時，「桅頂上」會蒐集您的個人資料。「桅頂上」也可能將商業夥伴或其他企業所提供的關於您的資訊與 「桅頂上」所擁有的您的個人資料相結合。")]), _vm._v(" "), _c('p', [_vm._v("在您註冊 「桅頂上」帳號並登入我們的服務後，我們即可辨別您的身分。 您得自由選擇是否提供個人資料給我們，但若特定資料欄位係屬必填欄位時，您若不提供該等資料，將無法使用相關的「桅頂上」產品及服務。")]), _vm._v(" "), _c('p', [_vm._v("「桅頂上」將自動接收並記錄您電腦和瀏覽器上的資料，包括 IP位址、「桅頂上」cookie的資料、軟體和硬體屬性以及您瀏覽的網頁紀錄。 在您使用「桅頂上」產品及服務期間，「桅頂上」得於全球地區將資料用作以下用途：客製化廣告及您看到的網頁內容、滿足您對產品和服務的要求、改進我們的服務、聯絡您、進行研究，以及提供內部及外部客戶不載有個人資料之市場分析或業務報告。 ")]), _vm._v(" "), _c('p', [_vm._v("除非是為了向您提供您所要求的產品或服務、獲得您的授權，或有以下情形，否則 「桅頂上」不會向任何其他人士或非關係企業提供您的個人資料，或與之分享：")]), _vm._v(" "), _c('ol', [_c('li', [_c('p', [_vm._v("\n                                我們向已簽署保密協議書之代表 「桅頂上」執行業務或與我們共事的值得信賴的合作夥伴提供這些資料。這些公司可能會將您的個人資料用於協助 「桅頂上」，就我們和行銷夥伴所提供產品及服務的事宜，與您進行溝通。但這些公司無獨立權利分享這些資料。\n                              ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("「桅頂上」會根據您的個人資料向您展示精準式行銷廣告：您瀏覽精準式行銷廣告或與廣告發生互動時，「桅頂上」不會向廣告主提供您的任何個人資料。然而，一旦瀏覽廣告或與廣告發生互動，即表示您同意廣告主假設您對廣告主的廣告有興趣，而向您展示精準式行銷廣告。")]), _vm._v(" "), _c('li', [_vm._v("「桅頂上」的廣告主：婚禮服務提供者 (如婚禮顧問、婚禮攝影、婚宴場地、喜餅/禮盒、海外婚禮 / 蜜月旅遊、婚戒/飾品等)，和非婚禮服務提供公司 (如產品、金融、通路、軟體公司等)。")]), _vm._v(" "), _c('li', [_vm._v("Cookie的設定和存取：「桅頂上」會在您的電腦上設定並存取與產品及服務有關的cookie，並允許某些 「桅頂上」網頁上刊登廣告的廣告主在您的電腦上設定並存取 cookie。其他公司將根據其自訂的隱私權政策使用其cookie，並非依據本政策。"), _c('br'), _vm._v("\n                              \t ")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("我們認為為了調查和防止非法活動、涉嫌詐欺、對人身安全有潛在威脅的狀況、對「桅頂上」服務條款的違反，或為了對上述情形採取應對措施，或法律另有規定，而有必要分享您的個人資料時。")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("如果「桅頂上」全部或部分業務被其他公司收購或合併，我們會將您的個人資料移轉給該公司。如果發生這種情況，「桅頂上」會在您的個人資料被移轉且將適用不同的隱私權政策前通知您。")])])]), _vm._v(" "), _c('p', [_vm._v("您可隨時查詢、閱覽、複製及修改個人 「桅頂上」帳號資料，包括行銷偏好設定 。")]), _vm._v(" "), _c('p', [_vm._v("「桅頂上」會不定時在行銷偏好設定頁面上增加新類別的行銷訊息。瀏覽此頁面的使用者可選擇退出接收新類別的行銷訊息，或按照所收訊息中的指示取消訂閱這些訊息。 我們保有權利向您傳送 「桅頂上」服務相關的特定訊息 (如服務公告、管理訊息)，這些訊息被視為您「桅頂上」帳號的一部分，您無法選擇退出接收。")]), _vm._v(" "), _c('p', [_vm._v("如果您要刪除您的「桅頂上」帳號，請與我們聯繫。"), _c('br'), _vm._v("\n                          我們已採取符合法規要求的實體、電子和程序防護措施，以保護您個人資料的安全。 「桅頂上」將不定時修訂本隱私權保護政策。當我們在個人資料的處理上有重大變更時，會將通知傳送到您在 「桅頂上」帳號中指定的主要電子郵件地址，或在我們的網站上張貼告示。")]), _vm._v(" "), _c('p', [_vm._v("生效日期：2017年9月01日")])])])])])])])])])])
}]}

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-8 offset-lg-4 offset-md-3 offset-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-fb btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("透過 Facebook 註冊")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-8 offset-lg-4 offset-md-3 offset-sm-2"
  }, [_c('form', {
    staticClass: "register-form"
  }, [_c('h4', {
    staticClass: "title text-center"
  }, [_vm._v("一般註冊")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label sr-only",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.fblogin == 1,
      "placeholder": "姓名"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label sr-only",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("信箱Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "disabled": _vm.fblogin == 1,
      "placeholder": "請填寫 Email 即為您的帳號"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label sr-only",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("密碼")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "請輸入密碼"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label sr-only",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("再輸入一次密碼")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "再輸入一次密碼"
    },
    domProps: {
      "value": (_vm.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement),
      expression: "agreement"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.agreement) ? _vm._i(_vm.agreement, "1") > -1 : (_vm.agreement)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.agreement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agreement = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.agreement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agreement = $$c
        }
      }
    }
  }), _vm._v("\n                                            我同意"), _c('a', {
    staticClass: "articles-txt-link",
    attrs: {
      "href": "/privacy",
      "target": "_blink"
    }
  }, [_vm._v("「會員服務使用條款及個人資料提供書」")]), _vm._v("的內容\n                                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v("註冊")])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title sr-only"
  }, [_c('span', [_vm._v("會員註冊")])])
}]}

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "main-block main-block-bg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-articles bck-views"
  }, [_c('h2', {
    staticClass: "title"
  }, [_c('span', [_vm._v(_vm._s(this.songView.title))]), _vm._v(" "), (!this.authorized) ? _c('span', {
    staticClass: "addtofav",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#loginpanel",
      "title": "會員登入"
    }
  }, [_c('i', {
    staticClass: "fa fa-heart-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("收藏")])]) : _vm._e(), _vm._v(" "), (this.authorized) ? _c('span', {
    staticClass: "addtofav",
    class: _vm.favoriteData,
    on: {
      "click": _vm.addToFavorite
    }
  }, [_c('i', {
    staticClass: "fa fa-heart-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v("收藏")])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("by " + _vm._s(this.songView.author))])]), _vm._v(" "), _c('article', {
    staticClass: "article-editor",
    domProps: {
      "innerHTML": _vm._s(this.songView.context)
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": '/songCategory/' + _vm.songView.category_id
    }
  }, [_c('span', {
    staticClass: "badge badge-primary"
  }, [_vm._v(_vm._s(_vm.songView.category_name))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "articles-items articles-songview"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg col-sm-6 push-sm-6"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.songView.link
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg col-sm-6 pull-sm-6"
  }, [_c('article', {
    staticClass: "article-editor article-lyrics",
    domProps: {
      "innerHTML": _vm._s(_vm.songView.lyric)
    }
  })])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "fb-like",
    attrs: {
      "data-href": 'https://www.weddingsung.com/songs/' + this.$route.params.id,
      "data-layout": "standard",
      "data-action": "like",
      "data-size": "small",
      "data-show-faces": "true",
      "data-share": "true"
    }
  }), _vm._v(" "), _c('Fbcomment', {
    attrs: {
      "videoId": this.$route.params.id
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.share), function(row, index) {
    return _c('div', {
      staticClass: "col-sm-6"
    }, [_c('div', {
      staticClass: "articles-box videoshare-box"
    }, [_c('div', {
      staticClass: "embed-responsive embed-responsive-16by9"
    }, [_c('iframe', {
      staticClass: "embed-responsive-item",
      attrs: {
        "src": row.link
      }
    })]), _vm._v(" "), _c('blockquote', {
      staticClass: "blockquote article-blockquote"
    }, [_c('h6', {
      staticClass: "title mb-0 text-primary"
    }, [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('footer', {
      staticClass: "blockquote-footer"
    }, [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('article', {
      staticClass: "article-editor"
    }, [_c('p', {
      staticClass: "txt"
    }, [_vm._v("\n                                                " + _vm._s(_vm._f("doubledot")(_vm._f("truncate")(row.context, 250))) + "\n                                              ")])])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "articles-box contact-box songshare-box"
  }, [_c('div', {
    staticClass: "text text-bg"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 offset-lg-3 col-md-8 offset-md-2"
  }, [_c('form', {
    staticClass: "contact-form songshare-form",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: " col-form-label-sm",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: " col-form-label-sm",
    attrs: {
      "for": "videolink"
    }
  }, [_vm._v("影片連結")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.link),
      expression: "link"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.link = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: " col-form-label-sm",
    attrs: {
      "for": "message"
    }
  }, [_vm._v("分享內容")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.context),
      expression: "context"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "id": "message",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.context)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.context = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.shareSong
    }
  }, [_vm._v("送出")])])])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title title-bg-music"
  }, [_c('span', [_vm._v("推薦歌曲 - 歌詞與video")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title"
  }, [_c('span', [_vm._v("歌曲使用分享")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "title text-primary text-center"
  }, [_vm._v("\n                                        如果你在婚禮上也使用過這首歌，"), _c('br'), _vm._v("歡迎上傳這首歌的婚禮 video\n                                      ")])
}]}

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fb-comments",
    attrs: {
      "data-href": 'https://www.weddingsung.com/songs/' + _vm.videoId,
      "data-width": "800",
      "data-numposts": "5"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('main', {
    staticClass: "main-body"
  }, [_c('topbar', {
    on: {
      "clicked": _vm.onClickChild
    }
  }), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('footbar')], 1)])
},staticRenderFns: []}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.songCategory), function(row, index) {
    return _c('div', {
      staticClass: "col-lg-4 col-md-6"
    }, [_c('div', {
      staticClass: "articles-box catalog-box"
    }, [(row.id == 6) ? _c('a', {
      attrs: {
        "href": '/topic'
      }
    }, [_c('figure', {
      staticClass: "pic articles-pic fitimg"
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": 'https://admin.weddingsung.com/upload/song/' + row.image_path
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('article', {
      staticClass: "article-editor",
      domProps: {
        "innerHTML": _vm._s(row.context)
      }
    })])]) : _c('a', {
      attrs: {
        "href": '/songCategory/' + row.id
      }
    }, [_c('figure', {
      staticClass: "pic articles-pic fitimg"
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": 'https://admin.weddingsung.com/upload/song/' + row.image_path
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('article', {
      staticClass: "article-editor",
      domProps: {
        "innerHTML": _vm._s(row.context)
      }
    })])])])])
  }), 0)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-block main-block-bg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-articles bck-views"
  }, [_c('h2', {
    staticClass: "title"
  }, [_c('span', [_vm._v("創造永遠美好回憶，值得花時間了解、選擇")]), _vm._v(" "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("婚禮歌曲魔力無窮，聆聽獨特愛情印記")])]), _vm._v(" "), _c('article', {
    staticClass: "article-editor"
  }, [_c('p', [_vm._v("一場真正的婚宴起始於求婚應允，接著開始籌備婚禮。")]), _vm._v(" "), _c('p', [_vm._v("我們針對婚禮流程中的<求婚/迎賓>、<新人進場>、<愛情回顧>、<婚宴配樂>、<送客/蜜月>，分別精心挑選婚禮歌曲和音樂、介紹每首婚禮歌曲，\n                              並附上曾經使用過該婚禮歌曲的婚禮 video，希望每對新人或婚禮顧問，都能找到專屬於自己和伴侶一生回味無窮的婚禮歌曲。  ")]), _vm._v(" "), _c('p', [_vm._v("除此之外，我們也為了想要有個主題式婚禮的新人，花費時間尋找歌詞內涵、歌曲旋律、歌曲數量皆有一定分量的歌者，\n                              讓整場婚禮都能有著一致的調性，如單一歌者、歌曲風格、婚禮氣氛等，這個分類命名為<主題歌曲>，將會陸續推出不同主題的婚禮歌曲推薦。")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title title-bg-music"
  }, [_c('span', [_vm._v("精選分類")])])
}]}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "top-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('form', {
    staticClass: "form-inline searchform",
    attrs: {
      "method": "get"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searching($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group input-group-sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "歌曲名稱 / 作者",
      "aria-describedby": "basic-addon1"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn",
    attrs: {
      "id": "basic-addon1"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searching
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline member-menu-login mb-0"
  }, [(!this.authorized) ? _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#loginpanel",
      "title": "會員登入"
    }
  }, [_vm._v("登入")]), _vm._v(" "), _c('div', {
    staticClass: "modal fade loginmodal loginmodal-vertical text-center",
    attrs: {
      "id": "loginpanel",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-md"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "fblogn"
  }, [_c('h6', {
    staticClass: "title title-loginform"
  }, [_vm._v("臉書登入")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fb btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fblogin
    }
  }, [_vm._v("Facebook登入")])]), _vm._v(" "), _c('h6', {
    staticClass: "title title-loginform"
  }, [_vm._v("一般登入")]), _vm._v(" "), _c('form', {
    staticClass: "loginform",
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "input-group form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "accountbox",
      "placeholder": "帳號/email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group form-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "passwordbox",
      "placeholder": "密碼"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登入")])])])])])])]) : _vm._e(), _vm._v(" "), (!this.authorized) ? _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "href": "/register",
      "title": "會員註冊"
    }
  }, [_vm._v("註冊")])]) : _vm._e(), _vm._v(" "), (this.authorized) ? _c('li', {
    staticClass: "list-inline-item member-menu-text dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "/",
      "id": "memberCenter",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v(_vm._s(_vm.UserName))]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "memberCenter"
    }
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": '/collection'
    }
  }, [_vm._v("會員收藏")])]), _vm._v("\n                          歡迎回來\n                          "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.userLogout
    }
  }, [_vm._v("登出")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "navbar navbar-toggleable-sm navbar-light"
  }, [_vm._m(3), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand main-logo",
    attrs: {
      "href": '/'
    }
  }, [_c('span', [_vm._v("桅頂上")])]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse main-menu",
    attrs: {
      "id": "navbarCollapse"
    }
  }, [_c('ul', {
    staticClass: "navbar-nav mt-2"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/about'
    }
  }, [_vm._v("緣起 "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("(current)")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/songsPick'
    }
  }, [_vm._v("挑歌秘笈")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "href": "/",
      "id": "navbarDropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("精選歌曲")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "navbarDropdownMenuLink"
    }
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": '/songsCatalog'
    }
  }, [_vm._v("分類說明")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": '/songCategory/1'
    }
  }, [_vm._v("求婚/迎賓")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": '/songCategory/2'
    }
  }, [_vm._v("新人進場")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": '/songCategory/3'
    }
  }, [_vm._v("愛情故事回顧")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": '/songCategory/4'
    }
  }, [_vm._v("婚宴配樂")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": '/songCategory/5'
    }
  }, [_vm._v("送客/蜜月")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": '/topic'
    }
  }, [_vm._v("特別企劃主題")])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": '/featured'
    }
  }, [_vm._v("頂上故事")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": '/hot'
    }
  }, [_vm._v("熱門話題")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/contact'
    }
  }, [_vm._v("聯絡我們")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "href": "#",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-primary text-center",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("會員登入")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-lock fa-lg"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler navbar-toggler-right",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbarCollapse",
      "aria-controls": "navbarCollapse",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
}]}

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_c('h3', {
    staticClass: "title sr-only"
  }, [_c('span', [_vm._v("About us")])]), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('div', {
    staticClass: "articles-box aboutus-box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('figure', {
    staticClass: "pic articles-pic"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "/static/images/aboutus-1.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('h4', {
    staticClass: "title text-primary"
  }, [_vm._v("Music\n                                                    "), _c('br'), _vm._v("Through Time")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("音樂是可以跳脫時間定律的神奇魔法！\n"), _c('br'), _vm._v("人會老相片會泛黃，影片雖可以紀錄，\n"), _c('br'), _vm._v("卻沒有閉上眼睛聽著歌，\n"), _c('br'), _vm._v("帶人瞬間穿越時空，回到過去的想像力！")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "articles-box aboutus-box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 push-md-6"
  }, [_c('figure', {
    staticClass: "pic articles-pic"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "/static/images/aboutus-2.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 pull-md-6"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('h4', {
    staticClass: "title text-primary"
  }, [_vm._v("Turning Love "), _c('br'), _vm._v("into Forever")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("婚禮歌曲常被挑選的原因，\n"), _c('br'), _vm._v("只因為旋律好聽、搭配婚禮儀式方便，\n"), _c('br'), _vm._v("對歌詞的含意和適用時機，缺少真正的了解，\n"), _c('br'), _vm._v("一個讓婚姻歷久彌新、愛意永不退色的契機因而錯過。\n"), _c('br'), _vm._v(" "), _c('br'), _vm._v("不論你是新人或婚禮顧問，\n"), _c('br'), _vm._v("希望在這裡可以找到屬於新人特有的婚禮歌曲。\n"), _c('br'), _vm._v(" "), _c('br'), _vm._v("我們相信用心選擇的婚禮歌曲，\n"), _c('br'), _vm._v("會跨越貴賤、身分、國界，為婚姻帶來真摯的祝福。\n"), _c('br'), _vm._v("我們歡迎新人分享婚禮歌曲影片，\n"), _c('br'), _vm._v("讓幸福的聲音可被更多人聽見！")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "articles-box aboutus-box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('figure', {
    staticClass: "pic articles-pic"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "/static/images/aboutus-3.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('h4', {
    staticClass: "title text-primary"
  }, [_vm._v("Wedding Song\n"), _c('br'), _c('small', {
    staticClass: "sub-title"
  }, [_vm._v("桅頂上聽見幸福的聲音")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("不管是入港，還是要出航\n"), _c('br'), _vm._v("桅頂上，我聽見嚮往，我看見方向")])])])])])])])])])])])])])
}]}

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.featured), function(row, index) {
    return _c('div', {
      staticClass: "col-xl-4 col-lg-4 col-md-6"
    }, [_c('div', {
      staticClass: "articles-box news-box"
    }, [_c('a', {
      attrs: {
        "href": '/featured/' + row.id
      }
    }, [_c('div', {
      staticClass: "text text-center"
    }, [_c('h5', {
      staticClass: "title text-primary"
    }, [_vm._v(_vm._s(row.title))]), _c('br'), _vm._v(" "), _c('p', {
      staticClass: "featured mb-0",
      domProps: {
        "innerHTML": _vm._s(row.context)
      }
    })])])])])
  }), 0)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title"
  }, [_c('span', [_vm._v("頂上故事 (Top Stories)")])])
}]}

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "inner-banner inner-banner-bg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "articles-box"
  }, _vm._l((_vm.pics), function(row, index) {
    return _c('figure', {
      staticClass: "pic articles-pic fitimg mb-0"
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": 'https://admin.weddingsung.com/upload/slide/' + row.image_path
      }
    })])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('form', {
    staticClass: "form-inline"
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "inlineFormCustomSelect"
    }
  }, [_vm._v("挑選歌曲")]), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "inlineFormCustomSelect"
    }
  }, [_vm._v("語文")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chooseLang),
      expression: "chooseLang"
    }],
    staticClass: "custom-select mb-2 mr-sm-2 mb-sm-0",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.chooseLang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.lang), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                        " + _vm._s(option.title) + "\n                                    ")])
  })], 2), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "inlineFormCustomSelect"
    }
  }, [_vm._v("節奏")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chooseTempo),
      expression: "chooseTempo"
    }],
    staticClass: "custom-select mb-2 mr-sm-2 mb-sm-0",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.chooseTempo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.tempo), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                        " + _vm._s(option.title) + "\n                                    ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "song-list"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.songdata), function(row, index) {
    return _c('div', {
      staticClass: "song-item row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_vm._v(_vm._s(row.author))]), _vm._v(" "), _c('div', {
      staticClass: "col-xl-3 col-md-2"
    }, [_vm._v(_vm._s(row.created_at.substr(0, 10)))]), _vm._v(" "), _c('div', {
      staticClass: "col-xl-1 col-md-2 text-center"
    }, [_c('router-link', {
      staticClass: "btn-song-detail",
      attrs: {
        "to": '/Songs/' + row.id
      }
    }, [_vm._v("聆聽去")])], 1)])
  })], 2)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title"
  }, [_c('span', [_vm._v("搜尋結果")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "song-item song-mainitem row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("歌曲")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("歌者")]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-3 col-md-2"
  }, [_vm._v("刊登時間")]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-1 col-md-2"
  })])
}]}

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fb-page fb-page-index",
    attrs: {
      "data-href": "https://www.facebook.com/WeddingSongsTWN/?fref=ts&pnref=story",
      "data-tabs": "timeline",
      "data-width": "290",
      "data-height": "200",
      "data-small-header": "true",
      "data-adapt-container-width": "true",
      "data-hide-cover": "false",
      "data-show-facepile": "true"
    }
  }, [_c('blockquote', {
    staticClass: "fb-xfbml-parse-ignore",
    attrs: {
      "cite": "https://www.facebook.com/WeddingSongsTWN/?fref=ts&pnref=story"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/WeddingSongsTWN/?fref=ts&pnref=story",
      "target": "_blink"
    }
  })])])
}]}

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('div', {
    staticClass: "articles-box contact-box"
  }, [_c('div', {
    staticClass: "row strict"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 text-bg"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._m(2), _vm._v(" "), _c('form', {
    staticClass: "contact-form",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Example label")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "姓名"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Another label")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "id": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addContact
    }
  }, [_vm._v("送出")])])])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title sr-only"
  }, [_c('span', [_vm._v("About us")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5"
  }, [_c('figure', {
    staticClass: "pic articles-pic mb-0 pic-left"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "/static/images/contact.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "title text-primary"
  }, [_vm._v("請填好以下的回覆表格"), _c('br'), _vm._v("我們會盡快和你聯絡")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "mobile"
    }
  }, [_vm._v("Another label")]), _vm._v(" "), _c('input', {
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "id": "mobile",
      "placeholder": "手機"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "message"
    }
  }, [_vm._v("Example textarea")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control form-control-sm",
    attrs: {
      "id": "message",
      "rows": "4",
      "placeholder": "留言訊息/婚禮歌曲使用video上傳"
    }
  })])])
}]}

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "main-block main-block-bg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-articles bck-views"
  }, [_c('h2', {
    staticClass: "title"
  }, [_c('span', [_vm._v("挑選婚禮歌曲的重要原則")])]), _vm._v(" "), _c('article', {
    staticClass: "article-editor"
  }, [_c('div', {
    staticClass: "row songpic-list"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "articles-box songpic-box"
  }, [_c('h5', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "sort-no text-primary"
  }, [_vm._v("1.")]), _vm._v("\n                                    清楚了解挑選歌曲適用於婚禮的原因\n                                  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n                                    從歌詞含意和歌曲旋律，判斷這首歌為何適用於婚禮。\n                                    如：表達愛意、寄託承諾、期待幸福、祝福未來…….\n                                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "articles-box songpic-box"
  }, [_c('h5', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "sort-no text-primary"
  }, [_vm._v("2.")]), _vm._v("\n                                    充分掌握挑選歌曲適用於婚禮的時機\n                                  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n                                    求婚/迎賓、進場(一次、二次) 、愛情回顧影片、婚宴、送客/蜜月，各時機可能有不同的適用條件，根據歌詞、歌曲特色大致判斷適用性。\n                                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "articles-box songpic-box"
  }, [_c('h5', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "sort-no text-primary"
  }, [_vm._v("3.")]), _vm._v("\n                                    追求挑選歌曲的品質而不在於數目\n                                  ")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("\n                                    婚禮過程有各個不同的流程，因此對歌曲要表達的訊息和情緒有不同的要求，很多時候，好好挑選一首婚禮歌曲在適當的時機播放，比放很多首更令人難忘。\n                                  ")])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_c('h3', {
    staticClass: "title sr-only"
  }, [_c('span', [_vm._v("挑歌秘訣")])]), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('ul', {
    staticClass: "songpic-imglist list-inline"
  }, [_c('li', {
    staticClass: "list-inline-item"
  }, [_c('figure', {
    staticClass: "pic articles-pic"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/songsPick-1.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text text-center"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("婚曲歌詞")]), _vm._v(" "), _c('article', {
    staticClass: "article-editor"
  }, [_c('p', {
    staticClass: "txt"
  }, [_vm._v("歌詞最能代表新人的心意，\n                                          "), _c('br'), _vm._v("寄予對方或告知親朋好友，\n                                          "), _c('br'), _vm._v("新人對婚姻的承諾與期待。")])])])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item"
  }, [_c('figure', {
    staticClass: "pic articles-pic"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/songsPick-2.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text text-center"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("歌曲旋律")]), _vm._v(" "), _c('article', {
    staticClass: "article-editor"
  }, [_c('p', {
    staticClass: "txt"
  }, [_vm._v("表達新人希望在婚禮時傳達的情緒，\n                                          "), _c('br'), _vm._v("緩慢的旋律能娓娓訴說深情，\n                                          "), _c('br'), _vm._v("而較快的旋律可以呈現歡樂的心情。")])])])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item"
  }, [_c('figure', {
    staticClass: "pic articles-pic"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/songsPick-3.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text text-center"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("歌曲節奏")]), _vm._v(" "), _c('article', {
    staticClass: "article-editor"
  }, [_c('p', {
    staticClass: "txt"
  }, [_vm._v("要考量適合的用法和時機，\n                                          "), _c('br'), _vm._v("和婚禮儀式或節目表演的畫面配合，\n                                          "), _c('br'), _vm._v("讓婚禮進行的每個階段都扣人心弦。")])])])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item"
  }, [_c('figure', {
    staticClass: "pic articles-pic"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/songsPick-4.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text text-center"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("播放曲數")]), _vm._v(" "), _c('article', {
    staticClass: "article-editor"
  }, [_c('p', {
    staticClass: "txt"
  }, [_vm._v("婚禮歌曲播放曲數有多種選擇，\n                                          "), _c('br'), _vm._v("適當搭配婚禮進行各階段，\n                                          "), _c('br'), _vm._v("完整呈現整個婚禮要傳達的美意。")])])])])])])])])])])])])])
}]}

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('form', {
    staticClass: "form-inline"
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "inlineFormCustomSelect"
    }
  }, [_vm._v("挑選歌曲")]), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "inlineFormCustomSelect"
    }
  }, [_vm._v("語文")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chooseLang),
      expression: "chooseLang"
    }],
    staticClass: "custom-select mb-2 mr-sm-2 mb-sm-0",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.chooseLang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.lang), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                          " + _vm._s(option.title) + "\n                                      ")])
  })], 2), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "inlineFormCustomSelect"
    }
  }, [_vm._v("節奏")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chooseTempo),
      expression: "chooseTempo"
    }],
    staticClass: "custom-select mb-2 mr-sm-2 mb-sm-0",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.chooseTempo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("節奏")]), _vm._v(" "), _vm._l((_vm.tempo), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                          " + _vm._s(option.title) + "\n                                      ")])
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "歌曲名稱 / 作者"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "song-list"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.songdata), function(row, index) {
    return _c('div', {
      staticClass: "song-item row"
    }, [_c('div', {
      staticClass: "col-md-4 song-item-name"
    }, [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 song-item-author"
    }, [_vm._v(_vm._s(row.author))]), _vm._v(" "), _c('div', {
      staticClass: "col-xl-3 col-md-2 col-8 song-item-date"
    }, [_vm._v(_vm._s(row.created_at.substr(0, 10)))]), _vm._v(" "), _c('div', {
      staticClass: "col-xl-1 col-md-2 col-4 text-center song-item-btn"
    }, [_c('a', {
      staticClass: "btn-song-detail",
      attrs: {
        "href": '/songs/' + row.id
      }
    }, [_vm._v("聆聽去")])])])
  })], 2)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title"
  }, [_c('span', [_vm._v("我的收藏")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "song-item song-mainitem row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("歌曲")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("歌者")]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-3 col-md-2"
  }, [_vm._v("刊登時間")]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-1 col-md-2"
  })])
}]}

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.hot), function(row, index) {
    return _c('div', {
      staticClass: "col-xl-3 col-lg-4 col-md-6"
    }, [_c('div', {
      staticClass: "articles-box news-box"
    }, [_c('a', {
      attrs: {
        "href": row.link,
        "target": "_blink"
      }
    }, [_c('figure', {
      staticClass: "pic articles-pic fitimg mb-0"
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": 'https://admin.weddingsung.com/upload/hot/' + row.image_path
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text text-center"
    }, [_c('h5', {
      staticClass: "title text-primary"
    }, [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('p', {
      staticClass: "txt mb-0",
      domProps: {
        "innerHTML": _vm._s(row.context)
      }
    })])])])])
  }), 0)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title"
  }, [_c('span', [_vm._v("熱門話題")])])
}]}

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-7 col-md-6 col-12"
  }, [_c('ul', {
    staticClass: "social-list list-inline"
  }, [_c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/WeddingSongsTWN/?fref=ts&pnref=story",
      "target": "_blink"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("facebook")])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("instagram")])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })]), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("twitter")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright-txt small"
  }, [_vm._v("\n            Copyright © 2017 weddingsung.com. All Rights Reserved.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-5 col-md-6 col-12 align-self-end"
  }, [_c('p', {
    staticClass: "copyright-txt copyright-cc clearfix"
  }, [_c('a', {
    staticClass: "pull-left",
    attrs: {
      "rel": "license",
      "href": "http://creativecommons.org/licenses/by-nc-sa/4.0/"
    }
  }, [_c('img', {
    staticStyle: {
      "border-width": "0"
    },
    attrs: {
      "alt": "創用 CC 授權條款",
      "src": "https://i.creativecommons.org/l/by-nc-sa/4.0/88x31.png"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "pull-left small",
    attrs: {
      "rel": "license",
      "href": "http://creativecommons.org/licenses/by-nc-sa/4.0/"
    }
  }, [_vm._v("本著作係採用 創用 CC 姓名標示-非商業性-相同方式分享 4.0 國際 授權條款授權.")])])])])])])
}]}

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "inner-banner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "articles-box"
  }, [_c('figure', {
    staticClass: "pic articles-pic fitimg mb-0"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": 'https://admin.weddingsung.com/upload/song/' + this.getCategory.image_origin
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('h3', {
    staticClass: "title text-primary"
  }, [_vm._v(_vm._s(this.getCategory.title))]), _vm._v(" "), _c('article', {
    staticClass: "article-editor",
    domProps: {
      "innerHTML": _vm._s(this.getCategory.longcontext)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.songdata), function(row, index) {
    return _c('div', {
      staticClass: "col-md-3"
    }, [_c('div', {
      staticClass: "articles-items"
    }, [_c('div', {
      staticClass: "articles-box topiclist-box"
    }, [_c('figure', {
      staticClass: "pic articles-pic"
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": 'https://admin.weddingsung.com/upload/song/' + row.image_path
      }
    })]), _vm._v(" "), _c('blockquote', {
      staticClass: "blockquote article-blockquote"
    }, [_c('h5', {
      staticClass: "title mb-0 text-primary"
    }, [_vm._v(_vm._s(row.title))]), _vm._v(" "), _c('article', {
      staticClass: "article-editor"
    }, [_c('p', {
      staticClass: "txt",
      domProps: {
        "innerHTML": _vm._s(row.context)
      }
    })]), _vm._v(" "), _c('ol', {
      staticClass: "topictop-list"
    }, [_c('li', [_c('span', [_vm._v(_vm._s(row.link_title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(row.author))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v(_vm._s(row.link2_title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(row.author))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v(_vm._s(row.link3_title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(row.author))])])]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-primary btn-block btn-sm",
      attrs: {
        "href": '/topicview/' + row.id
      }
    }, [_vm._v("MORE")])])])])])
  }), 0)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title"
  }, [_c('span', [_vm._v("精選婚禮主題")])])
}]}

/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "inner-banner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "articles-box"
  }, [_c('figure', {
    staticClass: "pic articles-pic fitimg mb-0"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": 'https://admin.weddingsung.com/upload/song/' + this.getCategory.image_origin
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('h3', {
    staticClass: "title text-primary"
  }, [_vm._v(_vm._s(this.getCategory.title))]), _vm._v(" "), _c('article', {
    staticClass: "article-editor",
    domProps: {
      "innerHTML": _vm._s(this.getCategory.longcontext)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('div', {
    staticClass: "song-list"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.songLatest), function(song) {
    return _c('div', {
      staticClass: "song-item row"
    }, [_c('div', {
      staticClass: "col-md-4 song-item-name"
    }, [_vm._v(_vm._s(song.title))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 song-item-author"
    }, [_vm._v(_vm._s(song.author))]), _vm._v(" "), _c('div', {
      staticClass: "col-xl-3 col-md-2 col-8 song-item-date"
    }, [_vm._v(_vm._s(song.updated_at.substr(0, 10)))]), _vm._v(" "), _c('div', {
      staticClass: "col-xl-1 col-md-2 col-4 text-center song-item-btn"
    }, [_c('a', {
      staticClass: "btn-song-detail",
      attrs: {
        "href": '/songs/' + song.id
      }
    }, [_vm._v("聆聽去")])])])
  })], 2)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_c('h3', {
    staticClass: "title title-bg-music"
  }, [_c('span', [_vm._v(_vm._s(this.songQty) + "首" + _vm._s(this.getCategory.title) + "歌曲")])]), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('form', {
    staticClass: "form-inline"
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "inlineFormCustomSelect"
    }
  }, [_vm._v("挑選歌曲")]), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "inlineFormCustomSelect"
    }
  }, [_vm._v("語文")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chooseLang),
      expression: "chooseLang"
    }],
    staticClass: "custom-select mb-2 mr-sm-2 mb-sm-0",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.chooseLang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("請選擇")]), _vm._v(" "), _vm._l((_vm.lang), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                            " + _vm._s(option.title) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "inlineFormCustomSelect"
    }
  }, [_vm._v("節奏")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chooseTempo),
      expression: "chooseTempo"
    }],
    staticClass: "custom-select mb-2 mr-sm-2 mb-sm-0",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.chooseTempo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("請選擇")]), _vm._v(" "), _vm._l((_vm.tempo), function(option) {
    return _c('option', {
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                            " + _vm._s(option.title) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "歌曲名稱 / 作者",
      "aria-describedby": "basic-addon1"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "song-list"
  }, [_vm._m(2), _vm._v(" "), _c('paginate', {
    staticClass: "paginate-langs",
    attrs: {
      "name": "languages",
      "list": _vm.songdata,
      "per": 10,
      "tag": "div"
    }
  }, _vm._l((_vm.paginated('languages')), function(songdata) {
    return _c('div', {
      staticClass: "song-item row"
    }, [_c('div', {
      staticClass: "col-md-3 song-item-name"
    }, [_vm._v(_vm._s(songdata.title))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 song-item-author"
    }, [_vm._v(_vm._s(songdata.author))]), _vm._v(" "), _c('div', {
      staticClass: "col-xl-2 col-md-2"
    }, [_vm._v(_vm._s(songdata.favorite))]), _vm._v(" "), _c('div', {
      staticClass: "col-xl-3 col-md-2 col-8 song-item-date"
    }, [_vm._v(_vm._s(songdata.created_at.substr(0, 10)))]), _vm._v(" "), _c('div', {
      staticClass: "col-xl-1 col-md-2 col-4 text-center song-item-btn"
    }, [_c('a', {
      staticClass: "btn-song-detail",
      attrs: {
        "href": '/songs/' + songdata.id
      }
    }, [_vm._v("聆聽去")])])])
  }), 0), _vm._v(" "), _c('nav', {
    staticClass: "song-pagination",
    attrs: {
      "aria-label": "Page navigation example"
    }
  }, [_c('paginate-links', {
    attrs: {
      "for": "languages",
      "simple": {
        prev: '上一頁',
        next: '下一頁'
      },
      "classes": {
        'ul': ['pagination', 'pagination-sm'],
        'li': 'page-item',
        '.next > a': ['page-link', 'next-link'],
        '.prev > a': ['page-link', 'prev-link', 'another-class'] // multiple classes
      }
    }
  })], 1)], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title title-bg-music"
  }, [_c('span', [_vm._v("最新上刊")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "song-item song-mainitem row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("歌曲")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("歌者")]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-3 col-md-2"
  }, [_vm._v("刊登時間")]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-1 col-md-2"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "song-item song-mainitem row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("歌曲")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_vm._v("歌者")]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-2 col-md-2"
  }, [_vm._v("収藏數")]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-3 col-md-2"
  }, [_vm._v("刊登時間")]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-1 col-md-2"
  })])
}]}

/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_c('h3', {
    staticClass: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.songView.title))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 offset-md-1"
  }, [_c('div', {
    staticClass: "articles-items"
  }, [_c('div', {
    staticClass: "articles-box topic-box"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('article', {
    staticClass: "article-editor"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.songView.context)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('div', {
    staticClass: "articles-box topic-box"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('h4', {
    staticClass: "title text-primary text-center"
  }, [_vm._v(_vm._s(_vm.songView.author) + "經典片段")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "articles-box videoshare-box"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.songView.link
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "articles-box videoshare-box"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.songView.link2
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "articles-box videoshare-box"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.songView.link3
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote article-blockquote"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "articles-box videoshare-box"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.songView.link4
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "articles-box videoshare-box"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.songView.link5
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "articles-box videoshare-box"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.songView.link6
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "articles-box videoshare-box"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.songView.link7
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "articles-box videoshare-box"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.songView.link8
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "articles-box videoshare-box"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.songView.link9
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-mid-style"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "to": '/topic/'
    }
  }, [_vm._v("回婚禮主題表單")])], 1)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_c('h4', {
    staticClass: "title text-primary text-center"
  }, [_vm._v(_vm._s(_vm.songView.author) + "歌單")]), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.songView.lyric)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "fb-like",
    attrs: {
      "data-href": 'https://www.weddingsung.com/songs/' + _vm.songView.id,
      "data-layout": "standard",
      "data-action": "like",
      "data-size": "small",
      "data-show-faces": "true",
      "data-share": "true"
    }
  }), _vm._v(" "), _c('Fbcomment', {
    attrs: {
      "videoId": _vm.songView.id
    }
  })], 1)])])])])])
},staticRenderFns: []}

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "main-block main-block-bg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-articles bck-views"
  }, [_c('h2', {
    staticClass: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.article.title))])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(this.article.context)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('div', {
    staticClass: "articles-box topic-box"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('h4', {
    staticClass: "title text-primary text-center"
  }, [_vm._v("頂上故事影片")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "articles-box videoshare-box"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": this.article.link
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "articles-box videoshare-box"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": this.article.link2
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "articles-box videoshare-box"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.article.link3
    }
  })]), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote article-blockquote"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "articles-box videoshare-box"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": this.article.link4
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "articles-box videoshare-box"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": this.article.link5
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "articles-box videoshare-box"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": this.article.link6
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "articles-box videoshare-box"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": this.article.link7
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "articles-box videoshare-box"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": this.article.link8
    }
  })])])])])])])])])])])])])])])
},staticRenderFns: []}

/***/ })
],[62]);


// WEBPACK FOOTER //
// static/js/app.d5010cafa94cd39864f7.js